module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-4.6d70da4b.png";